import { api } from './request'

const requestApi = {
  erpLogin: '/user/erpLogin',
  queryFirstPower: '/user/queryFirstPower',
  queryMenuByPid: '/user/queryMenuByPid',
  userLogout: '/common/userLogout',
  queryDeptDown: '/common/queryDeptDown', // 查询所属部门下拉框
  queryAllSellerDown: '/common/queryAllSellerDown', // 查询所有销售（不区分水运陆运）
  querySelectedProject: '/common/querySelectedProject', // 1.6.5 查询标的选择框列表

  // 费用类型
  queryCustFeeTypePageList: '/customer/queryCustFeeTypePageList',
  addCustFeeType: '/customer/addCustFeeType',
  editCustFeeType: '/customer/editCustFeeType',
  getCustFeeTypeById: '/customer/getCustFeeTypeById',
  queryDataDictionaryList: '/basicData/queryDataDictionaryList',
  addDataDictionary: '/basicData/addDataDictionary',

  // 结算类型
  queryCustomerPageList: '/customer/queryCustomerPageList', // 非结算对象
  querySettlementUnitList: '/customer/querySettlementUnitList', // 结算对象专用
  addCustomer: '/customer/addCustomer',
  editCustomer: '/customer/editCustomer',
  getCustomerById: '/customer/getCustomerById',
  getCustInfoByNameLike: '/customer/getCustInfoByNameLike',

  queryCustNameList: '/common/queryCustNameList', // 结算对象名称查询
  queryTruckNumberAndDriverDown: '/truck/queryTruckNumberAndDriverDown',
  // 查询中国省市区地名表
  queryBaseAreaList: '/common/queryBaseAreaList',

  queryTruckNumberDown: '/truck/queryTruckNumberDown', // 查询自营车牌号下拉框
  queryTruckOilCardDown: '/common/queryTruckOilCardDown', // 加油卡
  queryDriverDown: '/common/queryDriverDown', // 查询司机下拉框

  queryHolderNameList: `/common/queryHolderNameList`, // 持箱人名称查询
  queryContainerTypeList: `/common/queryContainerTypeList`, // 箱型查询
  queryPortNameList: `/common/queryPortNameList`, // 港口名称查询
  getLatestRate: `/common/getLatestRate`, // 获取最新的汇率
  queryFeeTypeList: `/common/queryFeeTypeList`, // 费用类型查询
  queryShipNameList: `/common/queryShipNameList`, // 船舶名称查询

  querySellerDown: '/common/querySellerDown', // 查询销售下拉框
  queryVoyageNumberList: '/common/queryVoyageNumberList', // 船舶航次查询

  updatePassword: '/user/updatePassword', // ERP修改密码
  sendSmsCode: '/common/sendSmsCode', // 发送短信验证码
  retrievePassword: '/common/retrievePassword', // 找回修改密码

  queryCustomerByNameLike: '/customer/queryCustomerByNameLike', // 查询客户是否存在

  getExistCustomerByName: '/customer/getExistCustomerByName',

  queryCustDown: '/common/queryCustDown', // 查询销售管理客户下拉框
  queryButtonByPid: '/user/queryButtonByPid', // 根据二级菜单id查按钮
  updateSelfHeadPortrait: '/user/updateSelfHeadPortrait',

  // 数据大屏
  queryDataScreenStatisticsInfo: '/statistics/queryDataScreenStatisticsInfo',
  queryDataScreenOrderList: '/statistics/queryDataScreenOrderList',
  queryDataScreenDailyOrder: '/statistics/queryDataScreenDailyOrder',
  // 数据BI - 数据大屏
  queryDataBiStatistics: '/dataBi/queryDataBiStatistics',
  queryCargoOwnerList: '/dataBi/queryCargoOwnerList',
  queryOperationalTrendsChart: '/dataBi/queryOperationalTrendsChart',

  queryGoodsData: '/basicData/queryGoodsData', // 查询货名字典
  queryCompanyLogisticsDown: '/common/queryCompanyLogisticsDown', // 查询物流公司下拉框
  checkSmsCode: '/common/checkSmsCode', // 校验验证码
  previewContract: '/platform/order/previewContract', // 订单详情-合同预览

  // 客服电话
  getServiceTel: '/common/getServiceTel',
  updateServiceTel: '/common/updateServiceTel',

  // 
  queryCargoOwnerListSelect: '/common/queryCargoOwnerListSelect', // 查询货主列表选择框
  queryUserListSelect: '/common/queryUserListSelect', // 查询成员列表选择框
  queryShipOwnerListSelect: '/common/queryShipOwnerListSelect', // 查询船主列表选择框
  queryShipListSelect: '/common/queryShipListSelect', // 查询船名列表选择框

  queryShipAisAndName: '/common/queryShipAisAndName', // 精准查询船舶ais
  queryDataBiShipMap: '/dataBi/queryDataBiShipMap',
  queryFeetype: '/common/queryFeetype',

  queryProjectListSelect: '/common/queryProjectListSelect',

  'verifyEnterpriseInfo': '/ship/verifyEnterpriseInfo', // 校验企业or个人信息

  // 1.5.0
  queryShipCXW: '/common/queryShipCXW',
  querySingleShipCXW: '/common/querySingleShipCXW',
  queryShipTrackCXW: '/common/queryShipTrackCXW',
}
export default requestApi

export const erpLogin = (data) => api(requestApi.erpLogin, data)
export const queryFirstPower = () => api(requestApi.queryFirstPower, {})
export const queryMenuByPid = (data) => api(requestApi.queryMenuByPid, data)
export const userLogout = (data) => api(requestApi.userLogout, data)
export const queryDeptDown = (data) => api(requestApi.queryDeptDown, data)
export const querySelectedProject = (data) => api(requestApi.querySelectedProject, data)

export const querySellerDown = (data) => api(requestApi.querySellerDown, data)
export const queryVoyageNumberList = (data) => api(requestApi.queryVoyageNumberList, data)

export const queryCustFeeTypePageList = (data) => api(requestApi.queryCustFeeTypePageList, data)
export const addCustFeeType = (data) => api(requestApi.addCustFeeType, data)
export const editCustFeeType = (data) => api(requestApi.editCustFeeType, data)
export const getCustFeeTypeById = (data) => api(requestApi.getCustFeeTypeById, data)
export const queryDataDictionaryList = (data) => api(requestApi.queryDataDictionaryList, data) // 查询数据字典列表
export const addDataDictionary = (data) => api(requestApi.addDataDictionary, data)

export const queryCustomerPageList = (data) => api(requestApi.queryCustomerPageList, data)
export const querySettlementUnitList = (data) => api(requestApi.querySettlementUnitList, data)
export const addCustomer = (data) => api(requestApi.addCustomer, data)
export const editCustomer = (data) => api(requestApi.editCustomer, data)
export const getCustomerById = (data) => api(requestApi.getCustomerById, data)
export const getCustInfoByNameLike = (data) => api(requestApi.getCustInfoByNameLike, data)

export const queryCustNameList = (data) => api(requestApi.queryCustNameList, data)
export const queryTruckNumberAndDriverDown = (data) => api(requestApi.queryTruckNumberAndDriverDown, data)
export const queryBaseAreaList = (data) => api(requestApi.queryBaseAreaList, data)

export const queryTruckNumberDown = (data) => api(requestApi.queryTruckNumberDown, data)
export const queryTruckOilCardDown = (data) => api(requestApi.queryTruckOilCardDown, data)

export const queryDriverDown = (data) => api(requestApi.queryDriverDown, data)

export const queryHolderNameList = (data) => api(requestApi.queryHolderNameList, data)
export const queryContainerTypeList = (data) => api(requestApi.queryContainerTypeList, data)
export const queryPortNameList = (data) => api(requestApi.queryPortNameList, data)
export const getLatestRate = (data) => api(requestApi.getLatestRate, data)
export const queryFeeTypeList = (data) => api(requestApi.queryFeeTypeList, data)
export const queryShipNameList = (data) => api(requestApi.queryShipNameList, data)

export const updatePassword = (data) => api(requestApi.updatePassword, data)
export const sendSmsCode = (data) => api(requestApi.sendSmsCode, data)
export const retrievePassword = (data) => api(requestApi.retrievePassword, data)

export const queryCustomerByNameLike = (data) => api(requestApi.queryCustomerByNameLike, data)

export const getExistCustomerByName = (data) => api(requestApi.getExistCustomerByName, data)

export const queryCustDown = (data) => api(requestApi.queryCustDown, data)

// 按钮权限接口
export const queryButtonByPid = (data) => api(requestApi.queryButtonByPid, data)
export const updateSelfHeadPortrait = (data) => api(requestApi.updateSelfHeadPortrait, data)

export const queryAllSellerDown = (data) => api(requestApi.queryAllSellerDown, data)

export const queryGoodsData = (data) => api(requestApi.queryGoodsData, data)
export const queryCompanyLogisticsDown = (data) => api(requestApi.queryCompanyLogisticsDown, data)
export const checkSmsCode = (data) => api(requestApi.checkSmsCode, data)
export const previewContract = (data) => api(requestApi.previewContract, data)

// 数据大屏
export const queryDataScreenStatisticsInfo = (data) => api(requestApi.queryDataScreenStatisticsInfo, data)
export const queryDataScreenOrderList = (data) => api(requestApi.queryDataScreenOrderList, data)
export const queryDataScreenDailyOrder = (data) => api(requestApi.queryDataScreenDailyOrder, data)

export const queryDataBiStatistics = (data) => api(requestApi.queryDataBiStatistics, data)
export const queryCargoOwnerList = (data) => api(requestApi.queryCargoOwnerList, data)
export const queryOperationalTrendsChart = (data) => api(requestApi.queryOperationalTrendsChart, data)

// 客服电话
export const getServiceTel = (data) => api(requestApi.getServiceTel, data)
export const updateServiceTel = (data) => api(requestApi.updateServiceTel, data)

export const queryCargoOwnerListSelect = (data) => api(requestApi.queryCargoOwnerListSelect, data)
export const queryUserListSelect = (data) => api(requestApi.queryUserListSelect, data)
export const queryShipOwnerListSelect = (data) => api(requestApi.queryShipOwnerListSelect, data)
export const queryShipListSelect = (data) => api(requestApi.queryShipListSelect, data)

export const queryShipAisAndName = (data) => api(requestApi.queryShipAisAndName, data)
export const queryDataBiShipMap = (data) => api(requestApi.queryDataBiShipMap, data)
export const queryFeetype = (data) => api(requestApi.queryFeetype, data)

export const queryProjectListSelect = (data) => api(requestApi.queryProjectListSelect, data)

export const verifyEnterpriseInfo = (data) => api(requestApi.verifyEnterpriseInfo, data)
export const queryShipCXW = (data) => api(requestApi.queryShipCXW, data)
export const querySingleShipCXW = (data) => api(requestApi.querySingleShipCXW, data)
export const queryShipTrackCXW = (data) => api(requestApi.queryShipTrackCXW, data)


// WEBPACK FOOTER //
// ./src/api/index.js